import './assets/css/index.css'
import { useState } from 'react'
import CommonHeader from '@components/common/CommonHeader'
import CommonSidebar from '@components/common/CommonSidebar'
import { useLocation } from 'react-router'
import Router from './routes/Router'
import UserProvider from './contexts/UserContext/UserProvider'

function App() {
  const { pathname } = useLocation()
  const [isOpend, setIsOpend] = useState(false)

  const openMenu = () => {
    setIsOpend(!isOpend)
  }

  return (
    <>
      <UserProvider>
        <div className="container">
          <CommonHeader openMenu={openMenu} isMain={pathname === '/main'} />
          {isOpend && <CommonSidebar openMenu={openMenu} />}
          <main>
            <Router />
          </main>
        </div>
      </UserProvider>
    </>
  )
}

export default App
